import React, { useState, useEffect, useContext } from "react";
import mixpanel from "mixpanel-browser";
import { Urls } from "../../Urls";
import classes from "./FreightRates.module.css";
import { Container } from "../Shared/FlexDiv/FlexDiv";
import Select from "react-select";
import { validateInputs } from "../DiscoverNow/Utitlity";
import { SelectLane, getKey, isDuplicate } from "./Utility";
import Loader from "../Loader";
import MobileBenchmarkResult from "./MobileBenchmarkResult";
import { CALENDLY_URL } from "../../config/calendly";
import PopupModal from "../Shared/PopupModal/PopupModal";
import BenchmarkHistory from "../Billing&Payment/BenchmarkHistory";
import ControlledModal from "../Shared/PopupModal/ControlledPopupModal/ControlledPopupModal";
import { HiArrowRight } from "react-icons/hi2";
import { FaTruck } from "react-icons/fa";
import CalendlyPopupButton from "../Shared/CalendlyPopupButton/CalendlyPopupButton";
import { AlertPopup } from "../Shared/AlertPopup/AlertPopup";
import { UserApiContext } from "../UserDetailsContext/UserDetailsContext";

const MAX_LANES = 3;

const FreightRatesMobile = ({
  show,
  userDetails,
  activeStep,
  allowedLanes,
  userInput,
  handleChange,
  getDataForLane,
  getSessionIDDirect,
  lspLanes,
  currentLaneList,
  allowedrate,
  resetData,
  userContent,
  allowedtransporter,
  alertPopupOpen,
  setAlertPopupOpen,
  alertPopupMessage,
  history,
  showNoCreditsModal,
  setShowNoCreditsModal,
}) => {
  const [stagedLanes, setStagedLanes] = useState([]);
  const [showCalendly, setShowCalendly] = useState(false);
  const [showBookingConfirmation, setShowBookingConfirmation] = useState(false);
  useEffect(() => {
    mixpanel.track("User has viewed mobile benchmark page", {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Benchmark",
      ModuleName: "mobile_benchmark",
      ActivityLog: "userViewedMobileBenchmarkPage",
      Data: "None",
      Definition: "User has viewed mobile benchmark page",
      ActivityType: "page_view",
      UserName: userDetails?.user_name,
      UserEmail: userDetails?.email,
      CompanyName: userDetails.company_name
        ? userDetails.company_name
        : userDetails.email
          ? userDetails.email.split("@")[1].split(".")[0]
          : ""
    });
  }, []);

  const formReady =
    validateInputs(
      userInput.origin,
      userInput.inputOrigin,
      userInput.destination,
      userInput.inputDestination,
      "",
      false
    ) && userInput.selectedTruckType;

  const buildLane = () => ({
    origin_coordinates: [
      userInput.origin.location.lon,
      userInput.origin.location.lat,
    ],
    destination_coordinates: [
      userInput.destination.location.lon,
      userInput.destination.location.lat,
    ],
    truck_type: userInput.selectedTruckType.value,
    laneKey: getKey(
      userInput.inputOrigin,
      userInput.inputDestination,
      userInput.selectedTruckType.value
    ),
    origin: userInput.origin,
    destination: userInput.destination,
    origin_name: userInput.origin.location_name,
    destination_name: userInput.destination.location_name,
  });

  const handleAddLane = () => {
    const lane = buildLane();
    if (isDuplicate(stagedLanes, lane.laneKey)) return;
    setStagedLanes([...stagedLanes, lane]);
    mixpanel.track("User has added a lane in mobile benchmark", {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Benchmark",
      ModuleName: "mobile_benchmark",
      ActivityLog: "userAddedLaneMobile",
      Data: `${lane.origin_name} → ${lane.destination_name} · ${lane.truck_type}`,
      Definition: "User has added a lane in mobile benchmark",
      ActivityType: "event_view",
      UserName: userDetails?.user_name,
      UserEmail: userDetails?.email,
      CompanyName: userDetails.company_name
        ? userDetails.company_name
        : userDetails.email
          ? userDetails.email.split("@")[1].split(".")[0]
          : ""
    });
    handleChange("origin", "");
    handleChange("destination", "");
    handleChange("inputOrigin", "");
    handleChange("inputDestination", "");
  };

  const handleRemoveLane = (index) => {
    const lane = stagedLanes[index];
    mixpanel.track("User has removed a lane in mobile benchmark", {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Benchmark",
      ModuleName: "mobile_benchmark",
      ActivityLog: "userRemovedLaneMobile",
      Data: lane?.laneKey ?? "unknown",
      Definition: "User has removed a lane in mobile benchmark",
      ActivityType: "event_view",
      UserName: userDetails?.user_name,
      UserEmail: userDetails?.email,
      CompanyName: userDetails.company_name
        ? userDetails.company_name
        : userDetails.email
          ? userDetails.email.split("@")[1].split(".")[0]
          : ""
    });
    setStagedLanes(stagedLanes.filter((_, i) => i !== index));
  };

  const handleSubmit = () => {
    if (allowedLanes === 0) {
      setShowNoCreditsModal(true);
      return;
    }
    let network = [...stagedLanes];
    if (formReady && network.length < allowedLanes) {
      network.push(buildLane());
    }
    if (network.length > allowedLanes) {
      network = network.slice(0, allowedLanes);
    }
    if (network.length > 0) {
      mixpanel.track("User has clicked view benchmark button", {
        ApplicationName: `${Urls.mixpanelappname}`,
        ScreenName: "LoRRI-Benchmark",
        ModuleName: "mobile_benchmark",
        ActivityLog: "userClickedViewBenchmarkMobile",
        Data: `${network.length} lane(s) submitted`,
        Definition: "User has clicked view benchmark button",
        ActivityType: "event_view",
        UserName: userDetails?.user_name,
        UserEmail: userDetails?.email,
        CompanyName: userDetails.company_name
          ? userDetails.company_name
          : userDetails.email
            ? userDetails.email.split("@")[1].split(".")[0]
            : ""
      });
      getSessionIDDirect(network);
    }
  };

  const handleTruckTypeChange = (value) => {
    handleChange("selectedTruckType", value);
    mixpanel.track("User has selected truck type in mobile benchmark", {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Benchmark",
      ModuleName: "mobile_benchmark",
      ActivityLog: "userSelectedTruckTypeMobile",
      Data: value?.label ?? "unknown",
      Definition: "User has selected truck type in mobile benchmark",
      ActivityType: "event_view",
      UserName: userDetails?.user_name,
      UserEmail: userDetails?.email,
      CompanyName: userDetails.company_name
        ? userDetails.company_name
        : userDetails.email
          ? userDetails.email.split("@")[1].split(".")[0]
          : ""
    });
  };

  const handleReset = () => {
    setStagedLanes([]);
    resetData();
  };

  const totalStaged = stagedLanes.length;
  const canAddMore =
    !!formReady &&
    totalStaged < MAX_LANES &&
    allowedLanes - totalStaged > 0;
  const submitReady = allowedLanes === 0 || formReady || totalStaged > 0;
  const remainingDisplay = allowedLanes - totalStaged;

  return (
    <Container className={classes["Mobile-Container"]}>
      <Loader show={show} />
      {userDetails?.policy?.benchmarknow?.allowed === "yes" ? (
        <>
          {activeStep === 0 ? (
            <div style={{ backgroundColor: "#EEF1F6", height: '100%' }}>
              <div className={classes["mobile-header"]}>
                <h2 className={classes["mobile-title"]}>
                  LoRRI Benchmark
                </h2>
                <p className={classes["mobile-subtitle"]}>
                  for contracted freight
                </p>
              </div>

              <div className={classes["mobile-card"]}>
                <p className={classes["mobile-card-desc"]}>
                  {allowedLanes === 0
                    ? "You've used all your free benchmark credits. Upgrade to continue benchmarking."
                    : `Benchmark up to ${allowedLanes} lane${allowedLanes === 1 ? "" : "s"} — one per free credit. Enter origin, destination and truck type.`}
                </p>

                <SelectLane
                  userInput={userInput}
                  handleChange={handleChange}
                  label="Origin"
                  valueKey="origin"
                  inputKey="inputOrigin"
                />

                <SelectLane
                  userInput={userInput}
                  handleChange={handleChange}
                  label="Destination"
                  valueKey="destination"
                  inputKey="inputDestination"
                />

                {userInput.origin &&
                  userInput.destination &&
                  userInput.inputOrigin &&
                  userInput.inputDestination &&
                  userInput.inputOrigin === userInput.inputDestination ? (
                  <span className={classes["s-error"]}>
                    Source and Destination cannot be same
                  </span>
                ) : null}

                <label className={classes["mobile-label"]}>
                  Truck type
                </label>
                <Select
                  options={userInput.options}
                  value={userInput.selectedTruckType}
                  onChange={handleTruckTypeChange}
                  onMenuOpen={() =>
                    getDataForLane(
                      userInput.origin,
                      userInput.destination,
                      userInput.inputOrigin,
                      userInput.inputDestination
                    )
                  }
                  isDisabled={
                    !validateInputs(
                      userInput.origin,
                      userInput.inputOrigin,
                      userInput.destination,
                      userInput.inputDestination,
                      "",
                      false
                    )
                  }
                  isLoading={userInput.isOptionsLoading}
                  placeholder="Select truck type..."
                  className="Truck_Type_Select"
                  classNamePrefix="Truck_Prefix"
                />

                {/* Staged lane chips */}
                {stagedLanes.length > 0 && stagedLanes?.map((l, i) => (
                  <div
                    key={l.laneKey}
                    className={classes["mobile-lane-chip"]}
                  >
                    <span>
                      {l.origin_name} → {l.destination_name} · {l.truck_type}
                    </span>
                    <button
                      onClick={() => handleRemoveLane(i)}
                      className={classes["mobile-lane-remove-btn"]}
                    >
                      ×
                    </button>
                  </div>
                ))}

                {/* Add lane button */}
                {canAddMore && (
                  <button
                    onClick={handleAddLane}
                    className={classes["mobile-add-lane-btn"]}
                  >
                    + Add lane
                  </button>
                )}

                <button
                  onClick={handleSubmit}
                  disabled={!submitReady}
                  className={classes["mobile-submit-btn"]}
                >
                  View benchmark &nbsp;→
                </button>
              </div>

              <div className={classes["mobile-remaining"]}>
                <span className={classes["mobile-remaining"]}>
                  Remaining Credits : {remainingDisplay}
                </span>
                {history && history.len > 0 && <PopupModal
                  buttonLabel={<span>History <i className="ml-1 fa fa-history" /></span>}
                  title="View History"
                  buttonClass="btn btn-sm btn-link d-flex justify-content-center align-items-center"
                  content={<BenchmarkHistory />}
                />}
              </div>

            </div>
          ) : (
            <MobileBenchmarkResult
              lspLanes={lspLanes}
              currentLaneList={currentLaneList}
              allowedrate={allowedrate}
              resetData={handleReset}
              allowedtransporter={allowedtransporter}
              allowedLanes={allowedLanes}
              onCalendlyScheduled={() => setShowBookingConfirmation(true)}
            />
          )}
        </>
      ) : (
        userContent
      )}

      {/* No-credits modal */}
      <ControlledModal
        isOpen={showNoCreditsModal}
        onClose={() => setShowNoCreditsModal(false)}
        hideHeader={true}
        centered={true}
        backdrop={true}
        backdropClassName={classes["credits-exhausted-modal-backdrop"]}
        size="sm"
        dialogClassName={classes["credits-exhausted-modal"]}
        content={
          <div style={{ textAlign: "center", padding: "16px 12px 8px 12px" }}>
            <div style={{ fontSize: "48px", marginBottom: "16px" }}>🎁</div>
            <h3 style={{ fontSize: "20px", fontWeight: "700", color: "#0f172a", marginBottom: "12px", letterSpacing: "-0.01em" }}>
              You're out of free credits
            </h3>
            <p style={{ fontSize: "14px", color: "#475569", lineHeight: "1.5", marginBottom: "24px" }}>
              Your 2 free credits cover 2 lanes. Book a quick demo to benchmark your lanes and see your full savings potential.
            </p>
            <button
              onClick={() => {
                setShowNoCreditsModal(false);
                setShowCalendly(true);
              }}
              style={{
                backgroundColor: "#23a455",
                color: "#ffffff",
                border: "none",
                borderRadius: "14px",
                padding: "14px 24px",
                fontSize: "15px",
                fontWeight: "600",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(35, 164, 85, 0.2)",
                transition: "all 0.2s ease"
              }}
            >
              Express interest <HiArrowRight style={{ fontSize: "16px" }} />
            </button>
            <button
              onClick={() => setShowNoCreditsModal(false)}
              style={{
                display: "block",
                margin: "16px auto 0 auto",
                fontSize: "14px",
                color: "#64748b",
                background: "none",
                border: "none",
                cursor: "pointer",
                fontWeight: "500",
                outline: "none",
                transition: "color 0.2s ease"
              }}
            >
              Maybe later
            </button>
          </div>
        }
      />
      <CalendlyPopupButton
        url={CALENDLY_URL}
        text=""
        open={showCalendly}
        moduleName="benchmark_lane_limit_mobile"
        style={{ display: "none" }}
        onCalendlyDropOff={() => setShowCalendly(false)}
        onCalendlyScheduled={() => {
          setShowCalendly(false);
          setShowBookingConfirmation(true);
        }}
      />
      <ControlledModal
        isOpen={showBookingConfirmation}
        onClose={() => setShowBookingConfirmation(false)}
        hideHeader={true}
        centered={true}
        backdrop={true}
        backdropClassName={classes["credits-exhausted-modal-backdrop"]}
        size="sm"
        dialogClassName={classes["credits-exhausted-modal"]}
        content={
          <div style={{ textAlign: "center", padding: "16px 12px 8px 12px" }}>
            <div style={{ display: "inline-flex", justifyContent: "center", marginBottom: "16px" }}>
              <div style={{ width: "48px", height: "48px", border: "2.5px solid #0f172a", borderRadius: "10px", overflow: "hidden", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: "#ffffff" }}>
                <div style={{ background: "#ef4444", width: "100%", color: "#ffffff", fontSize: "9px", fontWeight: "700", textTransform: "uppercase", padding: "2px 0", textAlign: "center", borderBottom: "2.5px solid #0f172a" }}>July</div>
                <div style={{ fontSize: "20px", fontWeight: "800", color: "#0f172a", lineHeight: "1.2" }}>17</div>
              </div>
            </div>
            <h3 style={{ fontSize: "20px", fontWeight: "800", color: "#0f172a", marginBottom: "10px", letterSpacing: "-0.01em" }}>
              Your demo is scheduled
            </h3>
            <p style={{ fontSize: "13px", color: "#64748b", lineHeight: "1.5", marginBottom: "24px" }}>
              You're booked. We've sent the invite to your work email and we'll send a reminder before the call.
            </p>
            <button
              onClick={() => {
                setShowBookingConfirmation(false);
                setShowCalendly(true);
              }}
              style={{
                backgroundColor: "#0f172a",
                color: "#ffffff",
                border: "none",
                borderRadius: "14px",
                padding: "14px 24px",
                fontSize: "15px",
                fontWeight: "600",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                transition: "all 0.2s ease"
              }}
            >
              Reschedule
            </button>
            <button
              onClick={() => setShowBookingConfirmation(false)}
              style={{
                display: "block",
                margin: "16px auto 0 auto",
                fontSize: "14px",
                color: "#64748b",
                background: "none",
                border: "none",
                cursor: "pointer",
                fontWeight: "500",
                outline: "none"
              }}
            >
              Back to benchmark
            </button>
          </div>
        }
      />
      <AlertPopup
        show={alertPopupOpen}
        onClose={() => setAlertPopupOpen(false)}
        withHeader={true}
        headerTitle="LoRRI Benchmark"
      >
        <div style={{ padding: "10px 0 16px 0", fontSize: "15px", color: "#333" }}>
          {alertPopupMessage}
        </div>
      </AlertPopup>
    </Container>
  );
};

export default FreightRatesMobile;
